import React, { FC } from 'react';
import AntRadio from 'antd/es/radio';
import SRadio from './Radio.style';
import { TRadioProps } from './Radio.type';
import { Text } from '../Typography';

const RadioGroup = AntRadio.Group;
const Radio: FC<TRadioProps> = props => {
  const { label, ...other } = props;

  return (
    <SRadio {...other}>
      {typeof label === 'string' ? (
        <Text className="radio-label ml-1" fontlevel={4}>
          {' '}
          {label}{' '}
        </Text>
      ) : (
        label
      )}
    </SRadio>
  );
};

export { RadioGroup, Radio };
